<head>
    <meta charset="UTF-8">
    <meta http-equiv="Content-type=text/html;charset=utf-8"/>
    <meta http-equiv="Content-Security-Policy" content="upgrade-insecure-requests">
    <script type="text/javascript" src="http://code.changer.hk/jquery/1.11.2/jquery.min.js"></script>
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">
    
    <style type="text/css">
        /*td过长，隐藏显示*/
        table td {
            max-width: 200px;
            word-wrap: break-word;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
        }
        table td:hover {
            white-space: normal;
            overflow: auto;
        }
    </style>

</head>

<template>
    <div id="app">
        <button @click="corAjaxRequest">跨域ajax请求</button>
         <input type="text" @keyup.enter="search" @input="search($event)"/>
        环境: 
        <select class="mw-form-control" style="width:80px;height:25px;-webkit-appearance:inherit;" name="env" id="env" ref="env" v-model="env" >
            <option value="prod">生产环境</option>
            <option value="test">测试环境</option>
            <option value="pre">预发环境</option>
        </select>
        
        SQL: <input type="text" id="sql" name="sql" ref="sql" value="SELECT * FROM `d_workorder`.`payoff_detail` where 1=1 ORDER BY `id` DESC limit 0,20;" size="100">
        
        <button @click="dbquerypost">dbquery</button>
        <!-- <img src="./assets/logo.png"> -->
            
            <table class="table table-bordered table-striped" align="center" >
                <tr v-for="user in users" :key="user.id">
                    <td>{{user.id}}</td><td>{{user.order_number}}</td><td>{{user.account_title}}</td><td>{{user.identity_card}}</td><td>{{user.amount}}</td>
                </tr>
            </table>

    </div>
</template>

<script>

// var sql = $("#sql").val();
// var env = $("#env").val();

// 1、 this.$router.push进行编程式路由跳转
// 2、 router-link 进行页面按钮式路由跳转
// 3、 this.$route.params获取路由传递参数
// 4、this.$route.query获取路由传递参数

// vue三种常用获取input值写法_June.1-CSDN博客_vue获取input的value值
// https://blog.csdn.net/qq_39043923/article/details/88688420
// 1. v-model 表单输入绑定
// 使用v-model创建双向数据绑定, 用来监听用户的输入事件以更新数据，并对一些极端场景进行一些特殊处理。
// 2. @input 监听输入框
// 输入框只要输入的值变化了就会触发 input 调用 search 数据实时获取通过 event.currentTarget.value 获取到
// 3. ref 获取数据
// 这种方式类似于原生DOM,但是ref获取数据更方便

    export default {
        name: 'App',
        // name: "search",
        data() {
            return {
                users: [],
                env:"prod"
            }
        },
        methods: {
            search(event){
                // @input 监听输入框
                // 输入框只要输入的值变化了就会触发 input 调用 search 数据实时获取通过 event.currentTarget.value 获取到
	          console.log(event.currentTarget.value)
	        },
            // Access to XMLHttpRequest at 'http://10.211.55.2:54321/json.data.json' from origin 'http://localhost:8080' has been blocked by CORS policy: No 'Access-Control-Allow-Origin' header is present on the requested resource.
            // 本地链接 : localhost:8080
            // 明显跨域了.
            corAjaxRequest() {
                this.axios.get('/api/json.data.json')
                .then(response => {
                    console.log(response)
                    this.users = response.data.data
                    // console.log(this.users)
                })
                .catch(error => {
                    console.log(error)
                })
            },
            dbqueryget() {
                this.axios.get('https://prod.dt.diandi.win/duliday/db_api.php')
                .then(response => {
                    console.log(response)
                    this.users = response.data.data
                    // console.log(this.users)
                })
                .catch(error => {
                    console.log(error)
                })
            },
            dbquerypost() {
                // 发送 POST 请求
                this.axios({
                  method: 'post',
                  url: 'https://prod.dt.diandi.win/duliday/db_api.php',
                  params: {
                    // env: 'prod',
                    // sql: 'SELECT * FROM `d_workorder`.`payoff_detail` where 1=1 ORDER BY `id` DESC limit 0,20;'
                    env: this.$refs.env.value,
                    sql: this.$refs.sql.value
                  },
                  headers: {
                		'Content-Type': 'application/x-www-form-urlencoded'
                },
                timeout: 1000
                })
                .then(response => {
                    console.log(this.env);
                    console.log(this.$refs.env.value);
                    console.log(this.$refs.sql.value);
                    // console.log(response)
                    this.users = response.data.data
                    // console.log(this.users)
                })
                .catch(error => {
                    console.log(error)
                })
            }
        },
        created() {
            this.axios.get('/api/json.data.json')
            .then(response => {
                // console.log(response)
                this.users = response.data.data
                // console.log(this.users)
            })
            .catch(error => {
                console.log(error)
            })
        },
    }
    
    // axios POST提交数据的三种请求方式写法
    // https://www.jianshu.com/p/c3b88438e92e

    // import axios from 'axios'
    // let data = new FormData();
    // data.append('code','1234');
    // data.append('name','yyyy');
    // axios.post(`${this.$url}/test/testRequest`,data)
    // .then(res=>{
    //     console.log('res=>',res);            
    // })
    
    // import axios from 'axios'
    // import qs from 'Qs'
    // let data = {"code":"1234","name":"yyyy"};
    // axios.post(`${this.$url}/test/testRequest`,qs.stringify({
    //     data
    // }))
    // .then(res=>{
    //     console.log('res=>',res);            
    // })

    </script>

    <style>
    
    </style>



// WEBPACK FOOTER //
// src/App.vue